import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const ReusableComponent = ({
    type = "text",
    label,
    value,
    onChange,
    options = [],
    getOptionLabel,
    error = false,
     onBlur,
    helperText = "",
    disabledValue,
    rowsCount,
    multiline,
    placeholder,
    InputProps,
    requireValue,
    marginSize,
    sx = {},
}) => {
    const handleChange = (event, newValue) => {
        if (type === "numeric") {
            const numericValue = event.target.value.replace(/[^0-9]/g, "");
            onChange(numericValue);
        } else {
            onChange(newValue || event.target.value);
        }
    };

    if (type === "select") {
        return (
            <Autocomplete
                options={options}
                getOptionLabel={getOptionLabel}
                value={value}
                onBlur={onBlur}
                onChange={handleChange}
                renderInput={(params) => (
                    <TextField {...params} label={label} error={error} helperText={helperText} required={requireValue}/>
                )}
                size="small"
                sx={{ marginBottom: marginSize ,...sx  }}
            />
        );
    }
    return (
        <TextField
            multiline={multiline}
            label={label}
            value={value}
            onChange={handleChange}
            fullWidth
            error={error}
            helperText={helperText}
            disabled={disabledValue}
            size="small"
            onBlur={onBlur}
            rows={rowsCount}
            sx={{ marginBottom: marginSize , ...sx  }}
            placeholder={placeholder}
            InputProps={InputProps}
            InputLabelProps={{ shrink: true }}
            required={requireValue}
        />
    );
};

export default ReusableComponent;
